<template>
  <div class="banner" :class="[currentLang, showBannerStep ? 'banner-step-show' : '']">
    <div class="banner-header">
      <div class="banner-left">
        <div class="banner-content">
          <div class="banner-content-title">{{ $t('propTrade.banner.title') }}</div>
          <div class="banner-content-desc">
            {{ $t('propTrade.banner.desc') }}
          </div>
        </div>
      </div>
      <el-button type="text" class="banner-more-btn" @click="toggleBannerContent">
        <div class="banner-more-btn-text">
          <u v-if="showBannerStep"> {{ $t('propTrade.button.viewLess') }}</u>
          <u v-else> {{ $t('propTrade.button.viewMore') }}</u>
          <img
            src="@/assets/images/propTrade/prop-trading-banner-arrow3.png"
            :class="['banner-more-btn-icon', showBannerStep ? 'rotate' : '']"
            alt=""
          />
        </div>
      </el-button>
    </div>
    <div class="banner-step" v-if="showBannerStep">
      <StepBanner :data="bannerData" :mobileWidth="stepBannerMobileWith" @changeStepBannerWidth="changeStepBannerWidth">
        <template v-slot="{ item }">
          <div class="banner-step-item">
            <div class="banner-step-header">
              <div class="bg-step-img">
                <img :src="require(`@/assets/images/propTrade/prop-trading-banner-step${item.index}.png`)" />
              </div>
              <div class="banner-step-title" :ref="`bannerItemTitle${item.index}`">
                <span> {{ item.title }}</span>
              </div>
            </div>
            <ul class="banner-step-content" :class="{ mobile: isMobile }">
              <li v-for="(desc, index) in item.desc" :key="index">
                <img src="~@/assets/images/propTrade/prop-trading-banner-arrow.png" alt="icon" />
                {{ desc }}
              </li>
            </ul>
          </div>
        </template>
      </StepBanner>
    </div>
  </div>
</template>

<script>
import StepBanner from '@/components/propTrading/components/common/StepBanner.vue';

export default {
  name: 'PropTradingBanner',
  components: { StepBanner },
  props: {
    immediateShowContent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showBannerStep: false,
      bannerData: [
        {
          title: this.$t('propTrade.banner.challengePhase'),
          desc: [
            this.$t('propTrade.banner.challengePhaseDesc.0'),
            this.$t('propTrade.banner.challengePhaseDesc.1'),
            this.$t('propTrade.banner.challengePhaseDesc.2')
          ],
          img: '~@/assets/images/propTrade/prop-trading-banner-arrow.png'
        },
        {
          title: this.$t('propTrade.banner.evaluationPhase'),
          desc: [
            this.$t('propTrade.banner.evaluationPhaseDesc.0'),
            this.$t('propTrade.banner.evaluationPhaseDesc.1'),
            this.$t('propTrade.banner.evaluationPhaseDesc.2')
          ],
          img: '~@/assets/images/propTrade/prop-trading-banner-arrow.png'
        },
        {
          title: this.$t('propTrade.banner.becomeAnEliteTrader'),
          desc: [
            this.$t('propTrade.banner.becomeAnEliteTraderDesc.0'),
            this.$t('propTrade.banner.becomeAnEliteTraderDesc.1'),
            this.$t('propTrade.banner.becomeAnEliteTraderDesc.2')
          ],
          img: '~@/assets/images/propTrade/prop-trading-banner-arrow.png'
        }
      ],
      textWrapList: {},
      isMobile: false
    };
  },
  computed: {
    currentLang() {
      return this.$store.state.common.lang;
    },
    stepBannerMobileWith() {
      let targetValue;
      switch (this.currentLang) {
        case 'es':
          targetValue = 768;
          break;
        case 'pt':
          targetValue = 936;
          break;
        case 'ko':
          targetValue = 896;
          break;
        // case 'ja':
        //   targetValue = 1000;
        //   break;
        case 'th':
          targetValue = 863;
          break;
        // case 'de':
        //   targetValue = 1000;
        //   break;
        case 'id':
          targetValue = 1008;
          break;
        case 'ar':
          targetValue = 917;
          break;
        case 'ms':
          targetValue = 1056;
          break;
        case 'vi':
          targetValue = 921;
          break;
        case 'zh_TW':
          targetValue = 915;
          break;
        case 'tl':
          targetValue = 1000;
          break;
        default:
          targetValue = 768;
          break;
      }
      return targetValue;
    }
  },
  mounted() {
    this.showBannerStep = this.immediateShowContent;
  },
  methods: {
    toggleBannerContent() {
      this.showBannerStep = !this.showBannerStep;
    },
    changeStepBannerWidth(width, isMobile) {
      this.isMobile = isMobile;
    }
  }
};
</script>
<style lang="scss" scoped>
.banner {
  font-family: Public Sans;
  background-image: url(~@/assets/images/propTrade/prop-trading-banner.png);
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 24px;
  border-radius: 12px;
  padding: 26px 43px 33px 58px;
  @include rtl-sass-value(background-position, right top, left top);
  &.banner-step-show {
    background-image: url(~@/assets/images/propTrade/prop-trading-step-banner.png);
    padding: 55px 43px 55px 58px;
  }

  &-header {
    display: flex;
    justify-content: space-between;
  }
  &-left {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  &-content {
    color: $white;
    &-title {
      max-width: none;
      font-weight: 700;
      margin-bottom: 8px;
      font-size: 38px;
      line-height: 45px;
    }

    &-desc {
      display: inline-block;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }

  &-more-btn {
    color: $white;
    font-size: 12px;
    white-space: normal;
    &:hover,
    &:focus {
      border-color: transparent;
      background: transparent;
    }

    &-text {
      display: flex;
      align-items: center;
      color: $white;
      font-size: 16px;
      font-weight: 500;
      min-width: 20px;
      u {
        text-decoration: none;
        @include rtl-sass-prop(padding-right, padding-left, 6px);
      }
    }

    &-icon {
      width: 20px;
      height: 20px;
      &.rotate {
        transform: rotate(180deg);
      }
    }
  }

  // StepBanner component
  &-step {
    padding-top: 30px;
    &-item {
      color: $white;
      position: relative;
      width: 100%;
    }

    &-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 21px;
    }
    .bg-step-img {
      width: 32px;
      @include rtl-sass-prop(margin-right, margin-left, 10px);
    }

    &-title {
      font-size: 26px;
      font-weight: 600;
      display: inline-block;
      color: #fff;
    }

    &-content {
      min-height: 112px;
      color: #fff;
      word-break: break-word;
      font-size: 16px;
      line-height: 21px;
      font-weight: 400;
      /deep/li {
        @include rtl-sass-value(text-align, left, right);
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        img {
          width: 14px;
          @include rtl-sass-prop(margin-right, margin-left, 10px);
        }
      }
    }
  }

  /deep/.el-carousel__container {
    height: 290px;
    border-radius: 8px;
  }

  /deep/ .pc-container {
    gap: 38px;
  }

  &.ar {
    .banner-step-content img {
      transform: rotate(180deg);
    }
  }
}

/deep/ .pc-container {
  gap: 20px;
}

@media (max-width: 1200px) {
  .banner {
    background-image: url(~@/assets/images/propTrade/prop-trading-banner-mid.png);
    padding: 32px 41px 32px 44px;
    &-content {
      &-title {
        line-height: 40px;
        font-size: 34px;
      }
      &-desc {
        line-height: 21px;
        font-size: 14px;
      }
    }

    &.banner-step-show {
      background-image: url(~@/assets/images/propTrade/prop-trading-step-banner-mid.png);
      padding: 44px;
    }

    &-step {
      &-content {
        font-size: 13px;
        line-height: 17px;
      }
    }
    /deep/ .pc-container {
      gap: 49px;
    }
  }
}

@media (max-width: 768px) {
  .banner {
    background-image: url(~@/assets/images/propTrade/prop-trading-banner-mobile.png);
    padding: 32px 30px 32px 42px;
    &-content {
      &-title {
        line-height: 28px;
        font-size: 24px;
      }
      &-desc {
        line-height: 18px;
        font-size: 12px;
      }
    }
    &.banner-step-show {
      padding: 42px;
      background-image: url(~@/assets/images/propTrade/prop-trading-step-banner-mobile.png);
    }
    &-more-btn-text u {
      display: none;
    }
    /deep/ .pc-container {
      gap: 0;
    }
  }
}
</style>
